import React from "react";
import { IoClose } from "react-icons/io5";
import { useAudio } from "../../../context/audio-context";

type OpenWrappedModalProps = {
  setOpenOpenWrappedModal: (open: boolean) => void;
  setOpenWrapped: (open: boolean) => void;
};

const WRAPPED_LOCAL_STORAGE_KEY = "deex_wrapped_2025_viewed";

const OpenWrappedModal: React.FC<OpenWrappedModalProps> = ({
  setOpenOpenWrappedModal,
  setOpenWrapped,
}) => {
  const { play } = useAudio();
  const handleViewWrapped = async () => {
    try {
      localStorage.setItem(WRAPPED_LOCAL_STORAGE_KEY, "true");
    } catch {}

    await play(); // ✅ user gesture safe

    setOpenWrapped(true);
    setOpenOpenWrappedModal(false);
  };

  const handleClose = () => {
    setOpenOpenWrappedModal(false);
  };

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center font-manrope bg-black/80 backdrop-blur-sm">
      <div className="relative w-11/12 max-w-[420px]  rounded-3xl bg-[#042741] text-white bg-wrappedBg bg-no-repeat bg-[center_85%] bg-cover px-6 pt-8 pb-7  overflow-hidden">
        {/* subtle gradient overlay to make text pop */}
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#042741]/40 via-[#042741]/60 to-[#042741]/90" />

        {/* Close button */}
        <button
          onClick={handleClose}
          aria-label="Close recap intro"
          className="absolute right-4 top-4 z-10"
        >
          <IoClose className="text-white text-[22px]" />
        </button>

        {/* Content */}
        <div className="relative z-10 flex flex-col h-full items-center text-center">
          {/* Top spacer */}
          <div className="flex-1" />

          {/* Emoji + heading + copy */}
          <div className="flex flex-col px-8 mt-10 items-center">
            <div className="mb-4" aria-hidden="true">
              <span className="text-[48px] ">🎉</span>
            </div>
            <h1 className="text-[32px] leading-tight md:text-[48px] font-semibold font-sora mb-4">
              Your 2025 Recap is Here!
            </h1>
            <p className="text-[13px] md:text-[14px] text-[#F1F3F5] mt-6 font-manrope font-semibold px-3">
              A year of trades, swaps, rewards, and smart money moves — all in
              one recap.
            </p>
          </div>

          {/* Bottom CTA */}
          <div className="flex-1" />
          <button
            onClick={handleViewWrapped}
            className="mb-2 w-full h-[48px] mt-28 rounded-[8px] bg-[#0A7BDE] text-gray-50 text-[15px] font-semibold hover:brightness-110 transition"
          >
            View My DeeX Wrapped
          </button>
        </div>
      </div>
    </div>
  );
};

export default OpenWrappedModal;
